import { useState } from "react";
import { Mic, MicOff, Video, VideoOff, SkipForward, Square, Play, Flag } from "lucide-react";
import { toast } from "sonner";
import { ReportDialog } from "@/components/chat/ReportDialog";

const Btn = ({ onClick, testId, className, children, title }) => (
  <button onClick={onClick} data-testid={testId} title={title}
    className={`flex h-12 items-center justify-center gap-2 rounded-full px-4 font-bold sm:px-5 transition-transform hover:scale-105 active:scale-95 ${className}`}>
    {children}
  </button>
);

export const Controls = ({ chat }) => {
  const [reportOpen, setReportOpen] = useState(false);
  const toggle = async (k) => {
    try { await chat.toggle(k); } catch { toast.error(k === "mic" ? "Nem sikerült elérni a mikrofont" : "Nem sikerült elérni a kamerát"); }
  };
  if (chat.status === "banned") return null;
  const idle = ["stopped", "left", "terminated"].includes(chat.status);
  const canReport = chat.status === "chatting" || (idle && chat.partnerNick);
  return (
    <div className="flex flex-wrap items-center justify-center gap-3">
      <ReportDialog chat={chat} open={reportOpen} onOpenChange={setReportOpen} />
      {canReport && (
        <Btn testId="report-partner-button" onClick={() => setReportOpen(true)} title="Partner jelentése" className="bg-[#241E3D] text-[#FF3B6C]">
          <Flag className="h-5 w-5" /><span className="hidden sm:inline">Jelentés</span>
        </Btn>
      )}
      <Btn testId="toggle-mic-button" onClick={() => toggle("mic")} title="Mikrofon"
        className={chat.media.mic ? "bg-[#00F0FF] text-[#0F0C1B]" : "bg-[#241E3D] text-white"}>
        {chat.media.mic ? <Mic className="h-5 w-5" /> : <MicOff className="h-5 w-5" />}<span className="hidden sm:inline">Mikrofon</span>
      </Btn>
      <Btn testId="toggle-webcam-button" onClick={() => toggle("cam")} title="Kamera"
        className={chat.media.cam ? "bg-[#FFD600] text-[#0F0C1B]" : "bg-[#241E3D] text-white"}>
        {chat.media.cam ? <Video className="h-5 w-5" /> : <VideoOff className="h-5 w-5" />}<span className="hidden sm:inline">Kamera</span>
      </Btn>
      {idle ? (
        <Btn testId="new-chat-button" onClick={chat.find} className="bg-gradient-to-r from-pink-500 via-purple-600 to-indigo-600 text-white">
          <Play className="h-5 w-5" /> Új beszélgetés
        </Btn>
      ) : (
        <>
          <Btn testId="skip-stranger-button" onClick={chat.next} className="bg-[#7C3AED] text-white shadow-[0_0_25px_rgba(124,58,237,0.45)]">
            <SkipForward className="h-5 w-5" /> Következő
          </Btn>
          <Btn testId="stop-chat-button" onClick={chat.stop} className="bg-[#EF4444] text-white">
            <Square className="h-4 w-4" /> Stop
          </Btn>
        </>
      )}
    </div>
  );
};
